import { render, staticRenderFns } from "./OrderFoodDialog.vue?vue&type=template&id=838efcd4&scoped=true"
import script from "./OrderFoodDialog.vue?vue&type=script&lang=js"
export * from "./OrderFoodDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodDialog.vue?vue&type=style&index=0&id=838efcd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838efcd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050store/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('838efcd4')) {
      api.createRecord('838efcd4', component.options)
    } else {
      api.reload('838efcd4', component.options)
    }
    module.hot.accept("./OrderFoodDialog.vue?vue&type=template&id=838efcd4&scoped=true", function () {
      api.rerender('838efcd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderFoodDialog.vue"
export default component.exports